<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="irrigationStats-modal">

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Irrigation Stats</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div style="display: flex; margin-top: 5px; margin-bottom: 10px; gap: 10px;">
        <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off" 
                ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; margin-left: 10px; margin-top: 5px; font-size: medium; border-radius: 4px; border: 1px solid darkgray;" />

        <button (click)="datesUpdated('Last 4 hrs')" class="btn btn-sm btn-primary" style="color: white; height: 30px; margin-top: 4px;" type="button">Last 4 hrs</button>
        <button (click)="datesUpdated('Last 8 hrs')" class="btn btn-sm btn-primary" style="color: white; height: 30px; margin-top: 4px;" type="button">Last 8 hrs</button>
        <button (click)="datesUpdated('Last 12 hrs')" class="btn btn-sm btn-primary" style="color: white; height: 30px; margin-top: 4px;" type="button">Last 12 hrs</button>
        <button (click)="datesUpdated('Last 24 hrs')" class="btn btn-sm btn-primary" style="color: white; height: 30px; margin-top: 4px;" type="button">Last 24 hrs</button>
        <!-- <button (click)="getIrrigationStats()" class="btn btn-primary btn-sm" style="color: white; margin-left: 20px; height: 30px; margin-top: 4px;" type="button">Calculate</button> -->
    </div>

    <p-table #irrStatsTable [exportFunction]="exportCsv" [columns]="irrigationStatsCols" [value]="irrigationStats" scrollHeight="30em" *ngIf="!awaitIrrigationStats; else loading">
        <ng-template pTemplate="header" let-columns>
            <tr style="height: 35px; margin-top: 1px;">
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [ngClass]="{'text-center': col.header != 'Controller Name'}" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr style="height: 35px;">
                <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    <i *ngIf="rowData.expanded" class="fa-solid fa-chevron-down" (click)="toggleIrrigationStatRow(rowData)" style="color: #1c4966; cursor: pointer;"></i>
                    <i *ngIf="!rowData.expanded" class="fa-solid fa-chevron-right" (click)="toggleIrrigationStatRow(rowData)" style="color: #1c4966; cursor: pointer;"></i>
                    {{ rowData.device.name }}
                </td>

                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngFor="let zoneStat of rowData.zoneStats">
                        <div *ngIf="rowData.expanded"> {{ zoneStat.zoneId }} </div>
                    </div>
                </td>
                
                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngFor="let zoneStat of rowData.zoneStats">
                        <div *ngIf="rowData.expanded"> {{ zoneStat.irrigationCount }} </div>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngFor="let zoneStat of rowData.zoneStats">
                        <div *ngIf="rowData.expanded"> {{ zoneStat.irrigationTimeHours }} </div>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngFor="let zoneStat of rowData.zoneStats">
                        <div *ngIf="rowData.expanded"> {{ zoneStat.waterConsumption }} </div>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngFor="let zoneStat of rowData.zoneStats">
                        <div *ngIf="rowData.expanded"> {{ zoneStat.utilization }} </div>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;" class="text-center">
                    {{ rowData.totalCount }}
                </td>

                <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;" class="text-center">
                    {{ rowData.totalTime }}
                </td>

                <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;" class="text-center">
                    {{ rowData.totalConsumption }}
                </td>

                <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;" class="text-center">
                    {{ rowData.totalUtilization }}
                </td>

            </tr>
        </ng-template>
    </p-table>

    <ng-template #loading>
        <div class="col-xs-4 col-lg-3">
            <i style="margin: 20px;" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            <span>Retrieving ...</span>
        </div>
    </ng-template>



</div>
